module.exports = __webpack_public_path__ + "static/media/introduction.a499e01b.jpg";